export enum ConfigType {
  JurisdictionPriceSheet = 'JURISDICTION_PRICE_SHEET',
  LinguisticPriceSheet = 'LINGUISTIC_PRICE_SHEET',
  RenewalsPriceSheet = 'RENEWAL_PRICE_SHEET',
  CompanyTmPreferences = 'COMPANY_TM_PREFERENCES',
}
